import "./../styles/appUpdateNotice.css";

function RefreshIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M20 12a8 8 0 1 1-2.2-5.4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20 5v5h-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Branded Tripway update notice used inside react-toastify.
 */
export default function AppUpdateNotice({
  title,
  hint,
  actionLabel,
  laterLabel,
  isRtl,
  onUpdate,
  onLater,
}) {
  return (
    <div
      className="app-update-card"
      dir={isRtl ? "rtl" : "ltr"}
      role="status"
      aria-live="polite"
    >
      <div className="app-update-card__icon">
        <RefreshIcon />
      </div>

      <div className="app-update-card__body">
        <p className="app-update-card__eyebrow">Tripway</p>
        <p className="app-update-card__title">{title}</p>
        {hint ? <p className="app-update-card__hint">{hint}</p> : null}

        <div className="app-update-card__actions">
          {onLater ? (
            <button
              type="button"
              className="app-update-card__btn app-update-card__btn--ghost"
              onClick={onLater}
            >
              {laterLabel}
            </button>
          ) : null}
          <button
            type="button"
            className="app-update-card__btn app-update-card__btn--primary"
            onClick={onUpdate}
          >
            {actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
